import './EnhancedEventView.scss';
import '../EventDetails/EventDetails.scss';
import EnhancedEventViewDetails from './EnhancedEventViewDetails/EnhancedEventViewDetails';
import EnhancedEventViewHeader from './EnhancedEventViewHeader/EnhancedEventViewHeader';
import EventDetailsHeader from '../EventDetails/EventDetailsHeader';
import { eventActivityType } from '../../constants/myBlockMonth';

const getClassForEventType = (activityType, index, eventList) => {
  switch(activityType){
    case eventActivityType.PAIRING : case eventActivityType.RESERVE : case eventActivityType.RAP : case eventActivityType.RAPH :
      return index === eventList.length-1 ? 'ev__cntr border-bottom' : 'ev__cntr';
    case eventActivityType.SICK: case eventActivityType.SICK_INS:
      return index === eventList.length-1 ? 'ev__sickEventCntr border-bottom__sickEvent' : 'ev__sickEventCntr';
    case eventActivityType.VACATION: case eventActivityType.SDO : case eventActivityType.VAC2448 :
      return index === eventList.length-1 ? 'ev__vacationEventCntr border-bottom__vacationEvent' : 'ev__vacationEventCntr';
    case eventActivityType.DSP:
      return index === eventList.length-1 ? 'ev__displacedPairingEventCntr border-bottom__displacedPairing' : 'ev__displacedPairingEventCntr';
    case eventActivityType.PIT: case eventActivityType.REASSIGN:
      return index === eventList.length-1 ? 'ev__reassignmentPeriodEventCntr border-bottom__reassignmentPeriod' : 'ev__reassignmentPeriodEventCntr';
    case eventActivityType.TRAINING: case eventActivityType.ITC:
      return index === eventList.length-1 ? 'ev__trainingEventCntr border-bottom__training' : 'ev__trainingEventCntr';
    case eventActivityType.GDO6 : case eventActivityType.GDO : case eventActivityType.TDO6 : case eventActivityType.TDO :
      return index === eventList.length-1 ? 'ev__GuaranteedDaysOffEventCntr border-bottom__guaranteedDaysOff' : 'ev__GuaranteedDaysOffEventCntr';
    default:
      return index === eventList.length-1 ? 'ev__cntr border-bottom' : 'ev__cntr';
  }
};

const EnhancedEventView = ({
  actualView, 
  events,
  handleViewAllClick,
  numberOfEvents, 
  selectedEventIndex, 
  setSelectedEventIndex,
  viewAll,
  noData
  }) => {

  return (
    <div className="c-event-details-view">
      <EventDetailsHeader
        handleViewAllClick={handleViewAllClick}
        numberOfEvents={numberOfEvents}
        selectedEventIndex={selectedEventIndex}
        setSelectedEventIndex={setSelectedEventIndex}
        viewAll={viewAll}
        noData={noData}
      />
      {!noData ?
        <div>
          {events.filter(el => {return el !== undefined}).map((event, index) => {
            return( 
              <div key={index} id={`event-details__${event.unique_id}`}>
                <div className={getClassForEventType(event.activityType, index, events)}>
                  <EnhancedEventViewHeader
                    actualView={actualView}  
                    eventType={event.activityType}
                    event={event}
                  />
                  <EnhancedEventViewDetails
                    actualView={actualView}
                    eventType={event.activityType}
                    pairingEvent={event} 
                  />
                </div>
              </div>
            )
          })}
        </div>
      :<div className="no-data-content" />}
    </div>
  );
}

export default EnhancedEventView;
